"use client";

import { FC } from "react";
import { usePathname } from "next/navigation";

import Shortcut from "../Shortcut";
import OutlinedIcon from "@/components/icons/HomeOutlined";
import FilledIcon from "@/components/icons/Home";

interface ForYouProps {
  onClose: () => void;
}

const ForYou: FC<ForYouProps> = ({ onClose }) => {
  const pathname = usePathname() as string;

  const handleClick = () => {
    onClose();
  };

  return (
    <Shortcut
      url="/"
      icon={<OutlinedIcon />}
      activeIcon={<FilledIcon />}
      label="For You"
      onClick={handleClick}
      isActive={pathname === "/"}
    />
  );
};

export default ForYou;
